import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {RichTextSchema} from '../richText'
import {FormLayoutSchema} from './formLayout'
import {TwoColumnFormLayoutSchema} from './twoColumnFormLayout'
import {MarketoCampaignSchema} from './marketoCampaign'
import {EloquaCampaignSchema} from './eloquaCampaign'

export const FormSchema = buildEntrySchemaFor('form', {
  fields: z.lazy(() =>
    z.object({
      heading: RichTextSchema.optional(),
      campaign: z.union([MarketoCampaignSchema, EloquaCampaignSchema]).optional(),
      layout: z.union([FormLayoutSchema, TwoColumnFormLayoutSchema]).optional(),
      layoutOption: z.union([FormLayoutSchema, TwoColumnFormLayoutSchema]),
      submitText: z.string(),
    }),
  ),
})

export type Form = z.infer<typeof FormSchema>
